import { mount } from 'svelte'
import App from '@/components/triggers/App.svelte'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('triggers-app')
  if (!el) return

  const mode = (el.dataset.mode ?? 'index') as 'index' | 'new' | 'edit'
  const triggerHashid = el.dataset.triggerHashid ?? ''
  const inboundEmailDomain = el.dataset.inboundEmailDomain ?? ''

  mount(App, {
    target: el,
    props: { mode, triggerHashid, inboundEmailDomain },
  })
})
